<template>
	<ul class="dropdown_list" :class="{'dropdown_list--overflow': overflowList}" role="menu">
		<li v-for="option in optionNormalize" :key="option.key" :data-js-id="option.key" role="menuitem">
			<dropdown-custom-list-btn :option="option" @close="$emit('close')" />
			<div class="dropdown_list--child" v-if="option.key === selectedKey">
				<slot :scopedChildrenList="childrenList" />
			</div>
		</li>
	</ul>
</template>

<script>
import DropdownCustomListBtn from '@/components/dropdown-custom/DropdownCustomListBtn';
export default {
	name: 'DropdownCustomList',
	components: {DropdownCustomListBtn},
	inject: ['reactiveInject'],
	props: {
		listOptions: {
			type: Array,
			default: function () {
				return [];
			},
		},
		overflowList: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		childrenList() {
			return this.reactiveInject.parentSelectedOption?.children ?? [];
		},
		selectedKey() {
			return this.reactiveInject.parentSelectedOption?.key ?? 'no key';
		},
		optionNormalize() {
			return this.listOptions.sort((a, b) => a.index - b.index).sort((a, b) => +a.disabled - +b.disabled);
		},
	},
};
</script>

<style scoped lang="scss">
.dropdown_list {
	padding: 5px 0;
	margin: 2px 0 0;
	list-style: none;
	background-color: #fff;
	border-radius: 4px;
	box-shadow: 0 6px 12px rgba(#000, 0.18);
	max-height: 40vh;
	overflow-y: auto;
	width: 100%;
	border-top: 1px solid rgba(#000, 0.15);
	border-bottom: 1px solid rgba(#000, 0.15);
	@media (min-width: $mobile) {
		border: 1px solid rgba(#000, 0.15);
	}
	&::-webkit-scrollbar-track {
		background-color: $white;
		border-bottom-right-radius: 3px;
		border-top-right-radius: 3px;
	}
	&::-webkit-scrollbar {
		width: 12px;
		background-color: $white;
		border-radius: 3px;
	}
	&::-webkit-scrollbar-thumb {
		background-color: $color-mid-grey;
		border: 2px solid $white;
		border-radius: 5px;
	}

	::v-deep {
		.dropdown_list--child & {
			max-height: none;
			border-radius: 0;
			margin: 0;
			box-shadow: none;
			background-color: $color-extra-light-grey;
		}
	}
}
.dropdown_list--overflow {
	@media (min-width: $mobile) {
		overflow: hidden;
	}
}
</style>
